import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { t } from '../../i18n.js'

// Country selection with search.
// `translations` is a subtree of config/locales/components/country_select/
// served by ApplicationHelper#jsx_t — see app/frontend/users/js/i18n.js for
// the lookup helper.
export default function CountrySelect({ value, countries, fieldName, valuationId, translations }) {
  const [selectedOption, setSelectedOption] = useState(null)

  // Initialize selected option from value prop
  useEffect(() => {
    if (value && countries) {
      const option = countries.find(c => c.value === value)
      setSelectedOption(option || null)
    }
  }, [value, countries])

  const handleChange = (option) => {
    setSelectedOption(option)
    
    // Dispatch custom event for Stimulus controller
    const event = new CustomEvent('country-changed', {
      detail: { value: option?.value || '' },
      bubbles: true
    })
    document.dispatchEvent(event)
  }

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={countries}
      placeholder={t('placeholder', translations)}
      isClearable
      isSearchable
      className="react-select-container"
      classNamePrefix="react-select"
      noOptionsMessage={() => t('no_options', translations)}
    />
  )
}

